import { Stack } from '@repletoryreach/sdk-ui';
import { useParams, useSearchParams } from 'react-router-dom';
import { ResetForm } from './components/ResetForm';
import { AuthCardHeader } from '../components/AuthCardHeader';
import { useT } from '../../../i18n/I18nProvider';

export default function ResetPasswordPage() {
  const t = useT();
  const { token } = useParams();
  const [params] = useSearchParams();
  const email = params.get('email') ?? '';
  return (
    <Stack gap="md">
      <AuthCardHeader title={t('auth.reset.title')} subtitle={t('auth.reset.hint')} />
      <ResetForm token={token ?? ''} email={email} />
    </Stack>
  );
}
